var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"sticky-container":""}},[_c('el-header',{directives:[{name:"sticky",rawName:"v-sticky"}],staticStyle:{"width":"100%","overflow":"hidden"}},[_c('common-aside')],1),(_vm.isIfremeController)?_c('el-main',{}):_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }